export const PREVIEW_SKELETON_CHIP_COUNT = 5;

export const PREVIEW_ANIMATION = {
  sectionExpandMs: 400,
  rowExpandMs: 320,
  chipStaggerMs: 90,
  titleDelayMs: 80,
  mediaDelayMs: 80 + 90 * PREVIEW_SKELETON_CHIP_COUNT + 120,
} as const;
